// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609301045/js/" + chunkId + "." + {"44":"5d46b5a1","225":"5e676dd4","481":"e6263877","486":"9d7a722d","770":"527b6ef1"}[chunkId] + ".0.7902777246669792.chunk.js";
};